import { Card, Button, Typography } from 'antd';
const avatar = 'https://img.freepik.com/free-vector/isometric-diet-infographic-concept-with-man-running-treadmill-vitamins-modern-gadgets-fitness-health-control-healthy-food-isolated_1284-38600.jpg?semt=ais_hybrid&w=740&q=80';

const { Text } = Typography;

export default function NavCard() {
  return (
      <div className='flex flex-col items-center mt-2 m-2'>
        <img src={avatar} alt="own" className='rounded-lg ' />
        <Text style={{ display: 'block', color: "#fff" }}>Own Your Nutrition</Text>
      </div>
  );
}
